<template>
    <div class="register-form">
        <transition :name="transitionName" mode="out-in">
            <UserData
                v-if="step === 1"
                @continue="completeFirstStep"
            />

            <UserDataPassword
                v-if="step === 2"
                @continue="completeSecondStep"
            />

            <UserCreated
                v-if="step === 3"
                @continue="completeThirdStep"
            />
        </transition>
    </div>
</template>
<script>

/**
 * External dependencies.
 */
import { mapState } from 'vuex';

/**
 * Internal dependencies.
 */
import UserCreated from './UserCreated';
import UserData from './UserData';
import UserDataPassword from './UserDataPassword';

export default {
    components: {
        UserCreated,
        UserData,
        UserDataPassword,
    },

    props: {
        onProgress: {
            required: true,
            type: Function,
        },
        onSubmit: {
            required: true,
            type: Function,
        },
        onComplete: {
            required: true,
            type: Function,
        },
    },

    computed: {
        ...mapState('register', [
            'step',
            'previousStep',
            'transitionEnabled',
        ]),

        /**
         * Gets the name of the transition.
         *
         * @returns {string} Transition name.
         */
        transitionName() {
            if (! this.transitionEnabled) {
                return '';
            }

            return this.step > this.previousStep
                ? 'slide-left'
                : 'slide-right';
        },
    },

    methods: {
        /**
         * Completes first step.
         */
        completeFirstStep() {
            this.onProgress();
        },

        /**
         * Completed second step.
         */
        async completeSecondStep() {
            if (! (await this.onSubmit())) {
                return;
            }

            this.onProgress();
        },

        /**
         * Completed third step.
         */
        completeThirdStep() {
            this.onComplete();
        },
    },
};
</script>
<style scoped lang="scss">
    @use './RegisterForm.scss';
</style>
